import { useEffect, useState } from "react";
import { FragmentDefiner } from "../../../GlobalHooks/useReadFragment";

import { showGuests } from "../../../Utils/Functions";
import { useFilters } from "../Filters.hook";

const FRAGMENT_GUESTS_OPTIONS = new FragmentDefiner(
	"Filter",
	` id
	  name `
);

export const FRAGMENT_GUESTS = new FragmentDefiner(
	"Filters",
	`guests {
		  ${FRAGMENT_GUESTS_OPTIONS.query()}
	  }`
);

export const useGuests = ({filters}) => {
	const [value, setValue] = useState(filters?.guests);
	const type = "number";

	useEffect(() => {
		setValue(filters?.guests)
	}, [filters?.guests])

	return {
		data: {
			value,
			setValue,
			type: type,
		},
	};
};
